module.exports = __webpack_public_path__ + "static/media/nav-icon.6159f3fc.svg";